import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs';
import { InterfacePolizasService } from 'app/main/interfaces/polizas/services/interface-polizas.service';
import { UtilsService } from '../services/utils.service';

export interface CanComponentDeactivate {
    canDeactivate: () => any;
    rowData: any;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    constructor(private interfacePolizasService: InterfacePolizasService, private utils: UtilsService) { }
    canDeactivate(component: CanComponentDeactivate,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): any {

        let url: string = state.url;
   
        const salir = component.canDeactivate ? component.canDeactivate() : true;

        if (salir !== true && salir !== undefined) {

            salir.subscribe(sale => {
                if (sale) {
                    this.interfacePolizasService.cambiarEditado(component.rowData[0].archivo).subscribe(resultado => {
                        this.utils.openSnackBar(resultado.message, 'close');
                    });
                }
            });
        }
        return salir === undefined ? true : salir;
    }
}
